import api from './api'
import { Group, CreateGroupRequest, Permission } from './types'

export const groupsService = {
  async getAll(): Promise<Group[]> {
    const response = await api.get<Group[]>('/auth/groups/')
    return response.data
  },

  async getById(id: number): Promise<Group> {
    const response = await api.get<Group>(`/auth/groups/${id}/`)
    return response.data
  },

  async create(data: CreateGroupRequest): Promise<Group> {
    const response = await api.post<Group>('/auth/groups/', data)
    return response.data
  },

  async update(id: number, data: Partial<CreateGroupRequest>): Promise<Group> {
    const response = await api.patch<Group>(`/auth/groups/${id}/`, data)
    return response.data
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/auth/groups/${id}/`)
  },

  async getPermissions(): Promise<Permission[]> {
    const response = await api.get<Permission[]>('/auth/permissions/')
    return response.data
  },
}

export default groupsService
